import { Container } from '#app/components/layout/container'
import { Flex } from '#app/components/layout/flex'
import { Grid } from '#app/components/layout/grid'
import { H1 } from '#app/components/typography/h1'
import { H2 } from '#app/components/typography/h2'
import { Lead } from '#app/components/typography/lead'
import { P } from '#app/components/typography/p'
import { Logo } from '#app/old/patterns/header'

export default function Index() {
	return (
		<Container>
			<H1 className="mt-16 text-center">Brand Kit</H1>
			<Lead className="mx-auto text-center">Guidelines and assets for presenting the VerveUI brand consistently.</Lead>
			<H2>Naming</H2>
			<P className="text-muted-600">"VerveUI" is the brand name and always spelled with a capital "V", and "UI".</P>
			<P className="text-muted-600">It is a single word and should not be spelled as "verveUI", "Verveui", or any other variation.</P>
			<H2>Logo</H2>
			<P>Use the VerveUI wordmark for stronger brand recognition. Do not alter these files in any way.</P>
			<Flex justify="between" items="center" gap="10">
				<div className="bg-muted-100 group relative max-w-[270px] cursor-pointer overflow-hidden rounded-xl p-20">
					<Logo />
					<Grid cols="2" rows="1" justify="stretch" align="stretch" className="text-muted-600 bg-muted-200 absolute bottom-0 left-0 w-full">
						{/* eslint-disable-next-line remix-react-routes/use-link-for-routes */}
						<a href="/favicons/favicon.svg" download="VerveUI.svg" className="hover:bg-muted-300 border-muted-300/30 border-t py-2 text-center text-xs">
							.svg
						</a>
						{/* eslint-disable-next-line remix-react-routes/use-link-for-routes */}
						<a href="/favicons/android-chrome-512x512.png" download="VerveUI.png" className="hover:bg-muted-300 border-muted-300/30 border-t border-l py-2 text-center text-xs">
							.png
						</a>
					</Grid>
				</div>
			</Flex>
		</Container>
	)
}
